import Vue from "vue";

/**
 * 이벤트 허브로 이용함 비부모간 컨포넌트 끼리 통신가능
 */
const eventHub = new Vue();
/**
 * mixin 기본기능
 */
export default {
  data: () => ({
    eventHub: eventHub,
  }),
  methods: {
    /**
     * 기본 얼럿 메시지 노출
     * @param {string} msg
     */
    alertShow: function(msg, time = 3000) {
      this.$store.state.alert.display = true;
      this.$store.state.alert.msg = msg;
      setTimeout(() => {
        this.$store.state.alert.display = false;
        this.$store.state.alert.msg = "";
      }, time);
    },
    /**
     * 얼럿 숨김
     */
    alertHide: function() {
      this.$store.state.alert.display = false;
      this.$store.state.alert.msg = "";
    },
    /**
     * 기본 progress
     */
    defaultProgressShow: function() {
      this.$store.state.progressDisplay = true;
    },
    /**
     * 기본 progress 숨김
     */
    defaultProgressHide: function() {
      this.$store.state.progressDisplay = false;
    },
    circularProgressShow: function(html) {
      this.$store.state.circularProgress.html = html;
      this.$store.state.circularProgress.display = true;
      this.$store.state.circularProgress.value = 0;
    },
    circularProgressSetValue: function(val) {
      val = !isNaN(val) ? val : 0;
      val = val > 100 ? 100 : val;
      this.$store.state.circularProgress.value = val;
    },
    circularProgressHide: function() {
      this.$store.state.circularProgress.html = "";
      this.$store.state.circularProgress.display = false;
    },
    moveEcOrderPage: function(order_id) {
      let domain = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop${this.$store.state.shopNo}/s_new/order_detail.php?`;
      let params = `order_id=${order_id}`;
      return domain + params;
    },
    moveEcUserPage: function(userId) {
      if (this.$store.state.mallType !== "imweb") {
        let domain = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop${this.$store.state.shopNo}/c/member_admin_d_f.php?`;
        let params = `user_id=${userId}`;
        return domain + params;
      } else {
        let shopurl = this.getAdminUrl();
        // https://surpinghelp.imweb.me/admin/member/list/?mc=m20250502b4a4d56b2ad1a&keyword=nana.lim@coggiri.com
        return `https://${shopurl}/admin/member/list?&keyword=${userId}`;
      }
    },
    getAdminUrl: function() {
      return sessionStorage.getItem(`${this.$store.state.mallId}_domain`);
    },
    getSampleData: () => {
      return {
        "#{USER_NAME}": "홍길동",
        "#{USER_ID}": "test123",
        "#{USER_EMAIL}": "test123@sample.com",
        "#{ORDER_DATE}": "2024-12-25 12:25:23",
        "#{ORDER_NAME}": "홍길동",
        "#{ORDER_NO}": "20990517-0000001",
        "#{ORDER_PRICE}": "10,000",
        "#{SHOP_NAME}": "쇼핑몰명",
        "#{PRODUCT_NAME}": "테스트상품명",
        "#{PRODUCT_CODE}": "P0000ABC",
        "#{SERIAL_CODE}": "ABCD-AC83-U17P-1234",
        "#{REGISTRATION_URL}": "https://쇼핑몰도메인/registration/index.html",
        "#{REGISTRATION_PERIOD}": "2025-01-01 ~ 2027-01-01",
        "#{CERT_INPUT_NAME}": "홍길동",
        "#{CERT_INPUT_EMAIL}": "test123@sample.com",
        "#{CERT_INPUT_PHONE}": "010-1234-5678",
        "#{CERT_PRODUCT_NAME}": "테스트상품명",
        "#{CERT_SERIAL_CODE}": "ABCD-AC83-U17P-U4YS",
      };
    },
    getIsOrderMessage: (msg_type) => {
      const order_group = [
        "payment_end",
        "shipping_start",
        "shipping_end",
        "buyed_confirm",
        "cancel_start",
        "cancel_end",
        "exchange_start",
        "exchange_end",
        "refund_start",
        "refund_end",
      ];
      return order_group.includes(msg_type);
    },
    getAbleSerialTag: (msg_type) => {
      const serial_group = ["buyed_confirm", "shipping_end"];
      return serial_group.includes(msg_type);
    },
    getUserTagList: function(is_order = true, is_serial_tag = false) {
      const user_tags = [
        {
          text: "#{USER_NAME}",
          desc: "회원 이름",
        },
        {
          text: "#{USER_ID}",
          desc: "회원 아이디",
        },
        {
          text: "#{USER_EMAIL}",
          desc: "회원 이메일",
        },
        {
          text: "#{SHOP_NAME}",
          desc: "쇼핑몰명",
        },
        {
          text: "#{PRODUCT_NAME}",
          desc: "상품명",
        },
        {
          text: "#{PRODUCT_CODE}",
          desc: "상품코드",
        },
      ];
      if (this.$store.state.appCode !== "cert_digital") {
        user_tags.push({
          text: "#{REGISTRATION_URL}",
          desc: "정품인증페이지",
        });
      }

      if (is_order) {
        user_tags.push(
          {
            text: "#{ORDER_DATE}",
            desc: "주문일",
          },
          {
            text: "#{ORDER_NAME}",
            desc: "주문자명",
          },
          {
            text: "#{ORDER_NO}",
            desc: "주문번호",
          },
          {
            text: "#{ORDER_PRICE}",
            desc: "주문금액",
          },
        );
        if (is_serial_tag) {
          user_tags.push({
            text: "#{SERIAL_CODE}",
            desc: "시리얼코드 (미인증 코드 발송)",
          });
        }
      } else {
        user_tags.push(
          {
            text: "#{REGISTRATION_PERIOD}",
            desc: "보증 기간",
          },
          {
            text: "#{CERT_INPUT_NAME}",
            desc: "인증시 입력 이름",
          },
          {
            text: "#{CERT_INPUT_EMAIL}",
            desc: "인증시 입력 이메일",
          },
          {
            text: "#{CERT_INPUT_PHONE}",
            desc: "인증시 입력 전화번호",
          },
          {
            text: "#{CERT_PRODUCT_NAME}",
            desc: "인증 상품명",
          },
          {
            text: "#{CERT_SERIAL_CODE}",
            desc: "인증 시리얼코드",
          },
        );
      }
      return user_tags;
    },
    getInitContentText: function(msg_type) {
      switch (msg_type) {
        case "payment_end":
          return "#{SHOP_NAME} \n#{ORDER_NAME} 님, 결제완료 되었습니다.\n주문일 : #{ORDER_DATE}\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n배송완료 후 정품 인증을 받으시고 혜택을 받으세요.";
        case "shipping_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 제품이 발송되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n배송완료 후 정품 인증을 받으시고 혜택을 받으세요.";
        case "shipping_end":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  구매하신 상품의 시리얼 코드를 확인하세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n시리얼코드 : #{SERIAL_CODE}";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  정품 인증을 받으시고 혜택을 받으세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n정품 인증 하러가기 : #{REGISTRATION_URL}";
          }
        case "buyed_confirm":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  구매하신 상품의 시리얼 코드를 확인하세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n시리얼코드 : #{SERIAL_CODE}";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님,  정품 인증을 받으시고 혜택을 받으세요.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n정품 인증 하러가기 : #{REGISTRATION_URL}";
          }
        case "cancel_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 취소접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
        case "cancel_end":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 취소완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
        case "exchange_start":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 교환접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
        case "exchange_end":
          return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 교환완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
        case "refund_start":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n디지털 상품의 경우 결제와 동시에 시리얼코드가 발송되며\n반품 처리가 되지 않으니 참고해주세요.";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품접수가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n빠르게 확인 및 조치하도록 하겠습니다. 감사합니다.";
          }
        case "refund_end":
          if (this.$store.state.appCode === "cert_digital") {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n디지털 상품의 경우 결제와 동시에 시리얼코드가 발송되며\n반품 처리가 되지 않으니 참고해주세요.";
          } else {
            return "#{SHOP_NAME}\n#{ORDER_NAME} 님, 반품완료가 되었습니다.\n주문번호 : #{ORDER_NO}\n주문상품 : #{PRODUCT_NAME}\n앞으로 더욱 좋은 서비스를 제공하도록 노력하겠습니다. 감사합니다.";
          }
        case "member_cert_end":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 정품 인증이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}\n정품 인증 혜택을 받으실 수 있습니다.";
        case "admin_cert_end":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}\n정품 인증 혜택을 받으실 수 있습니다.";
        case "admin_approval_end":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증 승인이 완료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}\n정품 인증 혜택을 받으실 수 있습니다.";
        case "expired_before":
          return "#{SHOP_NAME} \n정품 보증 기간이 만료 될 예정입니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "expired_after":
          return "#{SHOP_NAME} \n정품 보증 기간이 만료되었습니다.\n정품 인증 기간 : #{REGISTRATION_PERIOD}\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "member_cert_cancel":
          return "#{SHOP_NAME} \n정품 인증이 취소되었습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "admin_cert_cancel":
          return "#{SHOP_NAME} \n관리자에 의해 정품 인증이 취소되었습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
        case "member_lost_regist":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 정품 인증하신 상품이 분실 상태로 변경되었습니다.\n분실 상태일 경우 다른 사용자가 정품 인증을 할 수 없으며, 분실된 제품을 제3자가 정품인증을 시도하는 경우 관리자가 확인이 가능합니다.\n제품을 찾으시면 분실 취소로 변경하시어 보증기간 및 혜택을 받으시길 권장합니다.\n감사합니다.";
        case "admin_lost_regist":
          return "#{SHOP_NAME} \n#{USER_NAME}님, 관리자에 의해 정품 인증하신 상품이 분실 상태로 변경되었습니다.\n분실 상태일 경우 다른 사용자가 정품 인증을 할 수 없으며, 분실된 제품을 제3자가 정품인증을 시도하는 경우 관리자가 확인이 가능합니다.\n제품을 찾으시면 분실 취소로 변경하시어 보증기간 및 혜택을 받으시길 권장합니다.\n감사합니다.";
        case "member_lost_cancel":
          return "#{SHOP_NAME}\n#{USER_NAME}님, 분실된 제품을 잘 찾으셨나요?\n해당 제품은 정상적인 정품 인증 상태로 변경되었습니다.\n제품에 대한 보증기간 및 혜택을 받으실 수 있습니다.\n감사합니다.";
        case "lost_3rd_verify_member":
          return "#{SHOP_NAME}\n#{USER_NAME}님, 제3자가 분실 제품 인증을 시도하였습니다.\n관리자 확인하여 안내드리도록 하겠습니다.\n감사합니다.";
        case "lost_3rd_verify_admin":
          return "#{SHOP_NAME}\n제3자가 분실 제품 인증을 시도하였습니다.\n시리얼 코드 : #{CERT_SERIAL_CODE}";
      }
    },
    isTagUsed: (content, tag) => {
      return content.includes(tag);
    },
    getUseTypeByTag: async (M, tag, msg_type) => {
      try {
        const res = await M.api(M.entry("/get/message/detail/tag_check"), { search_tag: tag });
        if (res.count === 0) {
          return false;
        } else {
          return !res.use_list.includes(msg_type);
        }
      } catch (error) {
        console.error(error);
      }
    },
    isAllowedKakaoForDigital: function() {
      if (this.$store.state.appCode !== "cert_digital") {
        return true;
      } else {
        // cert_digital 앱 코드인 경우 카카오톡 발송이 허용되는지 여부
        const check_ids = ["a"];
        return check_ids.includes(this.$store.state.mallId);
      }
    },
    async waitForShopNo(timeout = 5000) {
      return new Promise((resolve, reject) => {
        if (this.$store.state.shopNo) {
          resolve(this.$store.state.shopNo);
          return;
        }

        const checkInterval = setInterval(() => {
          if (this.$store.state.shopNo) {
            clearInterval(checkInterval);
            clearTimeout(timeoutId);
            resolve(this.$store.state.shopNo);
          }
        }, 100);

        const timeoutId = setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("shop_no not available within timeout"));
        }, timeout);
      });
    },
  },
};
